import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import AudioPlayerNew from '../components/AudioPlayerNew';
import MoodReactiveAvatar from '../components/MoodReactiveAvatar';

const StoryVideoNew = () => {
  const navigate = useNavigate();
  const [audioPlaying, setAudioPlaying] = useState(false);
  const predictionId = localStorage.getItem('prediction_id');
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://taraanaya-prod-production.up.railway.app';
  const audioUrl = `${backendUrl}/api/static/audio/future_${predictionId}.mp3`;
  
  return (
    <div className="min-h-screen bg-cosmic-dawn px-5 py-8">
      <div className="max-w-md mx-auto">
        {/* Back Button */}
        <button 
          onClick={() => navigate(-1)}
          className="mb-8 p-2 hover:bg-stone-100 rounded-full transition-colors"
        >
          <ChevronLeft className="w-6 h-6 text-stone-700" />
        </button>
        
        <div className="space-y-8">
          {/* Mood-Reactive Avatar */}
          <div className="flex justify-center">
            <MoodReactiveAvatar 
              mood="mysterious"
              isPlaying={audioPlaying}
              size="xlarge"
              showParticles={audioPlaying}
            />
          </div>
          
          {/* Title */}
          <div className="text-center">
            <h1 className="font-serif text-3xl md:text-4xl font-medium text-stone-900 mb-2">
              Your Health Future
            </h1>
            <p className="text-sm text-stone-600">
              Sage Varta reveals your upcoming health journey and predictions
            </p>
          </div>
          
          {/* Audio Player Card */}
          <AudioPlayerNew 
            src={audioUrl}
            onPlayStateChange={setAudioPlaying}
          />
          
          {/* Read Instead Option */}
          <div className="flex justify-center">
            <button className="text-sm text-cosmic-600 hover:text-cosmic-700 font-medium transition-colors">
              📄 Read Instead →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryVideoNew;